// @ngInject

Models.FeedItemModel = function FeedItemModel(Enums, BaseModel) {
    return Class(BaseModel, {

        constructor: function constructor() {
            this.constructor.$super.call(this);
            this.__className = 'FeedItemModel';

            this.cachable = false;
        },

        mapChilds: function mapChilds() {
            return {activity: 'ActivityModel'};
        },

        afterMixingFrom: function afterMixingFrom(object) {
        },

        _dataOnlyInterceptor: function _dataOnlyInterceptor(copy) {
        },

        isSystemGenerated: function isSystemGenerated() {
            return this.data && !!this.data.system_generated;
        },

        isEmailType: function isEmailType(type) {
            return type && this.data && this.data.email_type_cd === Enums.EmailTypesCd[Enums.EmailTypes[type]];
        },

        deleteItem: function deleteItem() {
            return this.__parent.deleteItem(this);
        }
    });

};
